import 'core-js/stable';
import 'es6-promise/auto';
import 'url-search-params-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'app/redux/store';

import App from 'app/containers/App.js';
import {GlobalStyle} from 'app/styles/global';
import { initializeSentry } from 'config/sentry';

/*
STYLED COMPONENTS BUG FIX
https://github.com/styled-components/styled-components/issues/1593
*/
import { FONTFACE_CIRCULAR } from 'app/styles/fonts';

initializeSentry();

const loadFonts = () => {
  const fontStyle = document.createElement('style');
  fontStyle.innerHTML = FONTFACE_CIRCULAR;
  document.head.appendChild(fontStyle);
};

const onRender = () => {
  loadFonts();
};

ReactDOM.render(
  <Provider store={store}>
  <>
    <GlobalStyle />
    <App />
  </>
  </Provider>,
  document.getElementById('app'),
  onRender
);
